angular.module('FlexyBeautyApp.services')
    .factory('OfferManager', ['StoreAppCode', 'Offers', "$sce", "OfferService",
        function (StoreAppCode, Offers, $sce, OfferService) {
            return {

                companyActiveOfferSubscription: null,
                companyActiveOfferSubscriptionView: null,

                computeCompanyOfferCode: function (company) {
                    return company && company.activeOffer ? company.activeOffer.offerCode : null;
                },

                computeCompanyViewOfferCode: function (companyView) {
                    return companyView && companyView.activeOffer ? companyView.activeOffer.offerCode : null;
                },

                computeCompanyOfferLabel: function (company) {
                    if (company) {
                        const currentOfferCode = this.computeCompanyOfferCode(company);
                        const currentOffer = OfferService.allOffers.find(offer => offer.code === currentOfferCode);
                        return currentOffer && currentOffer.label;
                    }
                    return null;
                },

                computeCompanyNextOfferLabel: function (company) {
                    if (company) {
                        const currentOfferCode = this.computeCompanyOfferCode(company);
                        return this.computeNextOfferLabel(currentOfferCode);
                    }
                    return null;
                },

                computeNextOfferLabel: function (currentOfferCode) {
                    switch (currentOfferCode) {
                        case Offers.ATTRACT.code:
                            return Offers.MANAGE.label;
                        case Offers.MANAGE.code:
                            return Offers.BOOST.label;
                        case Offers.START.code:
                            return Offers.PLUS.label;
                        case Offers.PLUS.code:
                            return Offers.BOOST.label;
                        default:
                            return null;
                    }
                },

                hasCompanyAccessToFeature: function(company, storeAppCode) {
                    return !!company && !!company.activeOffer && !!company.subscriptions && !!company.subscriptions.find &&
                            company.subscriptions.find(subscription => !!subscription.storeApp && subscription.storeApp.code === storeAppCode && subscription.isActive) !== undefined;
                },

                hasCompanyAccessToOnlineReservation: function (company) {
                    return this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE) ||
                        this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE) ||
                        this.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_WEBSITE);
                },

                computeDashboardVideoUrl: function () {
                    return $sce.trustAsResourceUrl("https://www.youtube.com/embed/j28sk8oRT_c");
                },

                checkWithoutTillAndPosSubscription: function (companyView, editedSubscriptionView) {
                    const withoutTillSubscription = companyView
                        .getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE);
                    const posSubscription = companyView
                        .getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_POS_APP_CODE);
                    if (editedSubscriptionView === withoutTillSubscription) {
                        posSubscription.isActive = !withoutTillSubscription.isActive;
                    } else if (editedSubscriptionView === posSubscription) {
                        withoutTillSubscription.isActive = !posSubscription.isActive;
                    }
                },

                computeMandatoryBased: function (companyView, editedSubscriptionView) {
                    const mandatoryBasedSubscriptionViews = companyView.subscriptionsView
                        .filter(subscriptionView =>
                            subscriptionView !== editedSubscriptionView &&
                            subscriptionView.storeAppView.mandatoryBases === editedSubscriptionView.storeAppView.code);
                    mandatoryBasedSubscriptionViews
                        .forEach(subscriptionView => subscriptionView.isActive = editedSubscriptionView.isActive);
                    return mandatoryBasedSubscriptionViews;
                },

                isWithoutTillCompatibleWithActiveOffer: function (companyView) {
                    return (this.computeCompanyViewOfferCode(companyView) === Offers.PLUS.code);
                },

                hasAccessToCreativeMode: function (activeOfferCode) {
                    return activeOfferCode === Offers.PRESTIGE.code;
                },

                hasAccessToFeature: function(subscriptions, storeAppCode) {
                    return !!subscriptions && subscriptions.find &&
                            subscriptions.find(subscription => subscription.storeAppCode === storeAppCode && subscription.isActive) !== undefined;
                },

                computeWebsiteCustomizationTutorialVideoUrl: function (subscriptions) {
                    if (this.hasAccessToFeature(subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                        return "https://www.youtube.com/watch?v=Fazski8a3KE";
                    }
                    if (this.hasAccessToFeature(subscriptions, StoreAppCode.OPTION_WEBSITE)) {
                        return "https://www.youtube.com/watch?v=xcGoDxvLVwo";
                    }
                    return "";
                },

                computeDefaultRegisterOfferCode: function() {
                    return Offers.BOOST.code;
                },

                hasOfferAccessToStoreApp: function (activeOfferCode, storeAppView) {
                    const activeOffer = OfferService.allOffers.find(offer => offer.code === activeOfferCode);
                    return (!!storeAppView && !!activeOffer && !!activeOffer.storeAppCodes &&
                        (activeOffer.storeAppCodes.find(storeAppCode => storeAppCode === storeAppView.code) !== undefined));
                }
            }
        }
    ])

    .constant('Offers', {
        ATTRACT: {code: 'attract', label: 'Free'},
        MANAGE: {code: 'manage', label: 'Smart'},
        BOOST: {code: 'boost', label: 'Business'},
        START: {code: 'start', label: 'Start'},
        PLUS: {code: 'plus', label: 'Plus'},
        PRESTIGE: {code: 'prestige', label: 'Prestige'}
    })



// WEBPACK FOOTER //
// ./js/services/tools/OfferManager.js